import React from 'react'
import { TweenLite } from 'gsap'
import ClassNames from 'classnames'
import { TweenMax, Expo } from 'gsap'

const speed = 0.4
const ease = Expo.easeInOut
const delay = 0.1

class FadeImage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
    }
    this.imageHasLoaded = this.imageHasLoaded.bind(this)
  }

  componentDidMount() {
    this.theImage = new Image()
    this.theImage.onload = this.imageHasLoaded
    this.theImage.src = this.props.src
  }

  imageHasLoaded() {
    TweenMax.to(this.img, 0.4, { opacity: 1, ease: Expo.easeOut })
  }

  render() {
    return (
      <div
        className={ClassNames({
          FadeImage: true,
          'has-loaded': this.state.loaded,
        })}
      >
        <img
          ref={el => {
            this.img = el
          }}
          src={this.props.src}
        />
      </div>
    )
  }
}

export default FadeImage



// WEBPACK FOOTER //
// ./src/components/image.js